'use client';
import { lazy, Suspense, forwardRef, useRef, type ComponentProps, type ComponentRef } from 'react';
export type * from "/tmp/build-370/node_modules/@eliadmin/core/src/components/reservation/reservation-our-team.tsx";

type Props = NonNullable<ComponentProps<typeof import("/tmp/build-370/node_modules/@eliadmin/core/src/components/reservation/reservation-our-team.tsx").ReservationOurTeam>>;
const Deferred = lazy(() => import("@eliadmin/module-original/reservationTeam").then(m => ({ default: m.ReservationOurTeam })));
export function ReservationOurTeam(props: Props) {  return <Suspense fallback={null}><Deferred {...props} /></Suspense>; }

